import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    static get targets () {
        return ['list', 'button'];
    }

    buttonTargetConnected(element) {
        // todo: maybe load from API
        const classToRemove = element.dataset.removeClass;
        element.addEventListener('click', () => {
           this.listTarget.classList.remove(classToRemove);
           element.remove();
        });
    }
}